import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#e3e3e3",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-316Z" })
});
export default SvgShield;
